import React, { useState } from 'react';

const TournamentDashboard = () => {
  const [activeTab, setActiveTab] = useState('active');

  // Mock data for demonstration
  const mockActiveTournaments = [
    {
      id: 1,
      name: "US Open Golf Championship",
      match: "Longest Drive",
      status: "active",
      prizePool: 500,
      yourWager: 25,
      potentialPayout: 75,
      deadline: "2 days",
      participants: 8
    },
    {
      id: 2,
      name: "NBA Finals Game 7",
      match: "Total Points Over 220",
      status: "pending",
      prizePool: 1200,
      yourWager: 50,
      potentialPayout: 150,
      deadline: "Pending Resolution",
      participants: 12
    }
  ];

  const mockHistory = [
    {
      id: 3,
      name: "Champions League Final",
      match: "First Goal Scorer",
      status: "won",
      prizePool: 800,
      yourWager: 40,
      actualPayout: 160,
      resolvedDate: "May 15, 2024"
    },
    {
      id: 4,
      name: "Masters Tournament",
      match: "Hole-in-One",
      status: "lost",
      prizePool: 300,
      yourWager: 10,
      actualPayout: 0,
      resolvedDate: "April 28, 2024"
    }
  ];

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return '🟢';
      case 'pending': return '🟡';
      case 'won': return '🏆';
      case 'lost': return '❌';
      default: return '⚪';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'active': return 'Active';
      case 'pending': return 'Pending Resolution';
      case 'won': return 'Won';
      case 'lost': return 'Lost';
      default: return 'Unknown';
    }
  };

  return (
    <div className="tournament-dashboard">
      <div className="tournament-dashboard__header">
        <h3 className="tournament-dashboard__title">My Tournaments</h3>
        <div className="tournament-dashboard__tabs">
          <button 
            className={`tournament-dashboard__tab ${activeTab === 'active' ? 'tournament-dashboard__tab--active' : ''}`}
            onClick={() => setActiveTab('active')}
          >
            Active
          </button>
          <button 
            className={`tournament-dashboard__tab ${activeTab === 'history' ? 'tournament-dashboard__tab--active' : ''}`}
            onClick={() => setActiveTab('history')}
          >
            History
          </button>
        </div>
      </div>

      <div className="tournament-dashboard__content">
        {activeTab === 'active' && (
          <div className="tournament-dashboard__section">
            {mockActiveTournaments.length > 0 ? (
              <div className="tournament-dashboard__list">
                {mockActiveTournaments.map((tournament) => (
                  <div key={tournament.id} className="tournament-dashboard__item">
                    <div className="tournament-dashboard__item-header">
                      <h4 className="tournament-dashboard__item-title">{tournament.name}</h4>
                      <div className="tournament-dashboard__item-status">
                        <span className="tournament-dashboard__status-icon">{getStatusIcon(tournament.status)}</span>
                        <span className="tournament-dashboard__status-text">{getStatusText(tournament.status)}</span>
                      </div>
                    </div>
                    <div className="tournament-dashboard__item-match">
                      Match: {tournament.match}
                    </div>
                    <div className="tournament-dashboard__item-info">
                      <div className="tournament-dashboard__info-row">
                        <span>Your Wager: ${tournament.yourWager}</span>
                        <span>Prize Pool: ${tournament.prizePool}</span>
                      </div>
                      <div className="tournament-dashboard__info-row">
                        <span>Potential Payout: ${tournament.potentialPayout}</span>
                        <span>Participants: {tournament.participants}</span>
                      </div>
                      <div className="tournament-dashboard__info-row">
                        <span>Deadline: {tournament.deadline}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tournament-dashboard__empty">
                <p>No active tournaments</p>
                <span>Join a tournament to see it here</span>
              </div>
            )}
          </div>
        )}

        {activeTab === 'history' && (
          <div className="tournament-dashboard__section">
            {mockHistory.length > 0 ? (
              <div className="tournament-dashboard__list">
                {mockHistory.map((tournament) => (
                  <div key={tournament.id} className="tournament-dashboard__item">
                    <div className="tournament-dashboard__item-header">
                      <h4 className="tournament-dashboard__item-title">{tournament.name}</h4>
                      <div className="tournament-dashboard__item-status">
                        <span className="tournament-dashboard__status-icon">{getStatusIcon(tournament.status)}</span>
                        <span className="tournament-dashboard__status-text">{getStatusText(tournament.status)}</span>
                      </div>
                    </div>
                    <div className="tournament-dashboard__item-match">
                      Match: {tournament.match}
                    </div>
                    <div className="tournament-dashboard__item-info">
                      <div className="tournament-dashboard__info-row">
                        <span>Your Wager: ${tournament.yourWager}</span>
                        <span>Prize Pool: ${tournament.prizePool}</span>
                      </div>
                      <div className="tournament-dashboard__info-row">
                        <span>Payout: ${tournament.actualPayout}</span>
                        <span>Resolved: {tournament.resolvedDate}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="tournament-dashboard__empty">
                <p>No tournament history</p>
                <span>Your completed tournaments will appear here</span>
              </div>
            )}
          </div>
        )}
      </div>

      <div className="tournament-dashboard__summary">
        <div className="tournament-dashboard__summary-item">
          <span className="tournament-dashboard__summary-label">Total Earnings:</span>
          <span className="tournament-dashboard__summary-value">$160</span>
        </div>
        <div className="tournament-dashboard__summary-item">
          <span className="tournament-dashboard__summary-label">Win Rate:</span>
          <span className="tournament-dashboard__summary-value">50%</span>
        </div>
      </div>
    </div>
  );
};

export default TournamentDashboard;
